/**
 * 基于ES6重构Editor.md
 */
import CodeMirror from 'codemirror';
import Marked from 'marked';
import * as utils from './utils';

const $: any = (window as any).$;

const regexs = {
    atLink: /@(\w+)/g,
    mentionLink: /(?:^|\s+|<br\/?>)@(\w+)(?=\s+|$|<br\/?>)/g,
    email: /(\w+)@(\w+)\.(\w+)\.?(\w+)?/g,
    emailLink: /(mailto:)?([\w._]+)@(\w+)\.(\w+)\.?(\w+)?/g,
    emoji: /:([\w+-]+):/g,
    emojiDatetime: /(\d{1,2}:\d{1,2}:\d{1,2})/g,
    twemoji: /:(tw-([\w]+)-?(\w+)?):/g,
    fontAwesome: /:(fa-([\w]+)(-(\w+)){0,}):/g,
    editormdLogo: /:(editormd-logo-?(\w+)?):/g,
    pageBreak: /^\[[=]{8,}\]$/,
};

const classPrefix = 'markdown-panel__';

const classNames = {
    tex: classPrefix + 'tex',
};

// emoji
const emoji = {
    emoji: {
        path: 'http://www.webpagefx.com/tools/emoji-cheat-sheet/graphics/emojis/',
        ext: '.png',
    },

    twemoji: {
        path: 'http://twemoji.maxcdn.com/36x36/',
        ext: '.png',
    },
};

// const codemirrorUrl = 'https://cdnjs.cloudflare.com/ajax/libs/codemirror/5.40.2/';

const editormd = {
    title: 'Editor.md',
    version: '1.5.0',
    homePage: 'https://pandao.github.io/editor.md/',
    classPrefix,

    // 预设编辑器内建模式
    modes: ['reader', 'editor'],
    // 预设工具栏内建模式
    toolbarModes: {
        none: null,
        full: [
            // 'undo', 'redo', '|',
            'bold',
            'italic',
            'del',
            'quote',
            'ucwords',
            '|', // 'uppercase', 'lowercase',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            '|',
            'list-ul',
            'list-ol',
            'hr',
            '|',
            'link',
            'image',
            'code',
            'code-block',
            'table',
            'datetime',
            'emoji',
            'pagebreak',
            '|',
            'watch',
            'preview',
            'fullscreen',
            '|',
            'help'
        ],
        simple: [
            'bold',
            'italic',
            'del',
            'quote',
            '|',
            'h1',
            'h2',
            'h3',
            '|',
            'list-ul',
            'list-ol',
            'hr',
            '|',
            'link',
            'image',
            'code-block',
            '|',
            'watch',
            'fullscreen',
            '|',
            'help'
        ],
        mini: ['undo', 'redo', '|', 'watch', 'preview', '|', 'help'],
    },
    // 内建主题
    themes: ['default', 'dark'],
    // 内建编辑器（CodeMirror）主题
    editorThemes: [
        'default',
        '3024-day',
        '3024-night',
        'ambiance',
        'ambiance-mobile',
        'base16-dark',
        'base16-light',
        'blackboard',
        'cobalt',
        'eclipse',
        'elegant',
        'erlang-dark',
        'lesser-dark',
        'mbo',
        'mdn-like',
        'midnight',
        'monokai',
        'neat',
        'neo',
        'night',
        'paraiso-dark',
        'paraiso-light',
        'pastel-on-dark',
        'rubyblue',
        'solarized',
        'the-matrix',
        'tomorrow-night-eighties',
        'twilight',
        'vibrant-ink',
        'xq-dark',
        'xq-light',
    ],
    // 内建markdownn内容预览视图的主题
    previewThemes: ['default', 'dark'],
    // 依赖的第三方资源
    resources: {
        codemirror: {
            version: CodeMirror.version,
            baseUrl: 'https://cdnjs.cloudflare.com/ajax/libs/codemirror/' + CodeMirror.version,
        },
        prettify: {
            version: 'r298',
            baseUrl: 'https://s3.cn-north-1.amazonaws.com.cn/files.datafountain.cn/forums/ajax/libs/prettify/r298',
        },
        katex: {
            version: '0.11.0',
            baseUrl: 'https://s3.cn-north-1.amazonaws.com.cn/files.datafountain.cn/forums/ajax/libs/KaTeX/0.11.0',
        },
    },
    // 内建工具栏
    toolbar: {
        bold: { icon: 'iconfont icon-b', text: '', style: 'font-size: 13px' },
        italic: { icon: 'iconfont icon-xiexian', text: '', style: 'font-size: 13px' },
        del: { icon: 'iconfont icon-s', text: '', style: 'font-size: 14px' },
        quote: { icon: 'iconfont icon-shuangyinhao', text: '', style: 'font-size: 12px' },
        ucwords: { icon: 'iconfont icon-Aa', text: '', style: 'font-size: 13px' },

        h1: { icon: 'iconfont icon-h1', text: '', style: 'font-size: 13px' },
        h2: { icon: 'iconfont icon-h2', text: '', style: 'font-size: 13px' },
        h3: { icon: 'iconfont icon-h3', text: '', style: 'font-size: 13px' },
        h4: { icon: 'iconfont icon-h4', text: '', style: 'font-size: 13px' },
        h5: { icon: 'iconfont icon-h5', text: '', style: 'font-size: 13px' },
        h6: { icon: 'iconfont icon-h6', text: '', style: 'font-size: 13px' },
        'list-ul': { icon: 'iconfont icon-liebiao', text: '', style: 'font-size: 13px' },
        'list-ol': { icon: 'iconfont icon-123', text: '', style: 'font-size: 13px' },
        hr: { icon: 'fa-minus', text: '' },

        link: { icon: 'iconfont icon-lianjie', text: '', style: 'font-size: 13px' },
        image: { icon: 'iconfont icon-tupian', text: '', style: 'font-size: 13px' },
        code: { icon: 'iconfont icon-daima', text: '', style: 'font-size: 15px' },
        'code-block': { icon: 'iconfont icon-daima1', text: '', style: 'font-size: 16px' },
        file: { icon: 'iconfont icon-xiaofenxiang file-other', text: '', style: 'font-size:16px' },
        table: { icon: 'iconfont icon-biaoge', text: '', style: 'font-size: 13px' },
        datetime: { icon: 'iconfont icon-shijian', text: '' },
        emoji: { icon: 'iconfont icon-xiaolian', text: '' },
        pagebreak: { icon: 'fa-newspaper-o', text: '' },

        watch: {
            icon: 'iconfont icon-yanjing-false',
            iconActive: 'iconfont icon-yanjing',
            text: '',
            style: 'font-size: 14px',
            styleActive: 'font-size: 18px; padding: 3px 6px',
            state: true,
        },
        preview: { icon: 'iconfont icon-diannao', iconActive: 'iconfont icon-diannao', text: '', state: true },
        fullscreen: {
            icon: 'iconfont icon-quanping-false',
            iconActive: 'iconfont icon-quanping',
            text: '',
            state: true,
        },
        help: { icon: 'iconfont icon-wenhao', text: '' },

        // watch: { icon: 'iconfont icon-guankan', text: '', state: true },
        // preview: { icon: 'fa-desktop', text: '', state: true },
        // fullscreen: { icon: 'fa-arrows-alt', text: '', state: true },

        undo: { icon: 'fa-undo', text: '' },
        redo: { icon: 'fa-repeat', text: '' },
        uppercase: { icon: 'fa-font', text: '' },
        'reference-link': { icon: 'fa-anchor', text: '' },
        'preformatted-text': { icon: 'fa-file-code-o', text: '' },
        'html-entities': { icon: 'fa-copyright', text: '' },
        'goto-line': { icon: 'fa-terminal', text: '' }, // fa-crosshairs
        search: { icon: 'fa-search', text: '' },
        unwatch: { icon: 'fa-eye-slash', text: '' },
        clear: { icon: 'fa-eraser', text: '' },
        info: { icon: 'fa-info-circle', text: '' },
        lowercase: { icon: '', text: 'a' },
    },
    // shortcuts
    keyMaps: {
        'Ctrl-1': 'h1',
        'Ctrl-2': 'h2',
        'Ctrl-3': 'h3',
        'Ctrl-4': 'h4',
        'Ctrl-5': 'h5',
        'Ctrl-6': 'h6',
        'Ctrl-B': 'bold', // if this is string ==  editormd.toolbarHandlers.xxxx
        'Ctrl-D': 'datetime',

        'Ctrl-E': function() {
            // emoji
            const cm = (this as any).cm;
            const cursor = cm.getCursor();
            const selection = cm.getSelection();

            if (!(this as any).settings.emoji) {
                alert('Error: settings.emoji == false');
                return;
            }

            cm.replaceSelection(':' + selection + ':');

            if (selection === '') {
                cm.setCursor(cursor.line, cursor.ch + 1);
            }
        },
        'Ctrl-Alt-G': 'goto-line',
        'Ctrl-H': 'hr',
        'Ctrl-I': 'italic',
        'Ctrl-K': 'code',

        'Ctrl-L': function() {
            const cm = (this as any).cm;
            const cursor = cm.getCursor();
            const selection = cm.getSelection();

            const title = selection === '' ? '' : ' "' + selection + '"';

            cm.replaceSelection('[' + selection + '](' + title + ')');

            if (selection === '') {
                cm.setCursor(cursor.line, cursor.ch + 1);
            }
        },
        'Ctrl-U': 'list-ul',

        'Shift-Ctrl-A': function() {
            const cm = (this as any).cm;
            const cursor = cm.getCursor();
            const selection = cm.getSelection();

            if (!(this as any).settings.atLink) {
                alert('Error: settings.atLink == false');
                return;
            }

            cm.replaceSelection('@' + selection);

            if (selection === '') {
                cm.setCursor(cursor.line, cursor.ch + 1);
            }
        },

        'Shift-Ctrl-C': 'code',
        'Shift-Ctrl-Q': 'quote',
        'Shift-Ctrl-S': 'del',
        'Shift-Ctrl-K': 'tex', // KaTeX

        'Shift-Alt-C': function() {
            const cm = (this as any).cm;
            const cursor = cm.getCursor();
            const selection = cm.getSelection();

            cm.replaceSelection(['```', selection, '```'].join('\n'));

            if (selection === '') {
                cm.setCursor(cursor.line, cursor.ch + 3);
            }
        },

        'Shift-Ctrl-Alt-C': 'code-block',
        'Shift-Ctrl-H': 'html-entities',
        'Shift-Alt-H': 'help',
        'Shift-Ctrl-E': 'emoji',
        'Shift-Ctrl-U': 'uppercase',
        'Shift-Alt-U': 'ucwords',
        'Shift-Ctrl-Alt-U': 'ucfirst',
        'Shift-Alt-L': 'lowercase',

        'Shift-Ctrl-I': function() {
            const cm = (this as any).cm;
            const cursor = cm.getCursor();
            const selection = cm.getSelection();

            const title = selection === '' ? '' : ' "' + selection + '"';

            cm.replaceSelection('![' + selection + '](' + title + ')');

            if (selection === '') {
                cm.setCursor(cursor.line, cursor.ch + 4);
            }
        },

        'Shift-Ctrl-Alt-I': 'image',
        'Shift-Ctrl-L': 'link',
        'Shift-Ctrl-O': 'list-ol',
        'Shift-Ctrl-P': 'preformatted-text',
        'Shift-Ctrl-T': 'table',
        'Shift-Alt-P': 'pagebreak',
        F9: 'watch',
        F10: 'preview',
        F11: 'fullscreen',
    },

    // 编辑器默认设置
    defaults: {
        mode: 'gfm', // gfm or markdown
        name: '', // Form element name
        value: '', // value for CodeMirror, if mode not gfm/markdown
        theme: '', // Editor.md self themes, before v1.5.0 is CodeMirror theme, default empty
        // editorTheme: 'default', // Editor area, this is CodeMirror theme at v1.5.0
        // previewTheme: '', // Preview area theme, default empty
        markdown: '', // Markdown source code
        appendMarkdown: '', // if in init textarea value not empty, append markdown to textarea
        width: '100%',
        height: '100%',
        path: '/static/markdown/', // Dependents module file directory
        pluginPath: '', // If this empty, default use settings.path + "../plugins/"
        delay: 1000, // Delay parse markdown to html, Uint : ms
        autoLoadModules: true, // Automatic load dependent module files
        watch: true,
        placeholder: 'Enjoy Markdown! coding now...',
        gotoLine: true,
        codeFold: false,
        autoHeight: false,
        autoFocus: true,
        autoCloseTags: true,
        searchReplace: true,
        syncScrolling: true, // true | false | "single", default true
        readOnly: false,
        tabSize: 4,
        indentUnit: 4,
        lineNumbers: true,
        lineWrapping: true,
        autoCloseBrackets: true,
        showTrailingSpace: true,
        matchBrackets: true,
        indentWithTabs: true,
        styleSelectedText: true,
        matchWordHighlight: true, // options: true, false, "onselected"
        styleActiveLine: true, // Highlight the current line
        dialogLockScreen: true,
        dialogShowMask: true,
        dialogDraggable: true,
        dialogMaskBgColor: '#fff',
        dialogMaskOpacity: 0.1,
        fontSize: '13px',
        saveHTMLToTextarea: false,
        disabledKeyMaps: [],

        /* eslint-disable @typescript-eslint/no-empty-function */
        onload: function() {},
        onresize: function() {},
        onchange: function() {},
        onwatch: null,
        onunwatch: null,
        onpreviewing: function() {},
        onpreviewed: function() {},
        onfullscreen: function() {},
        onfullscreenExit: function() {},
        onscroll: function() {},
        onpreviewscroll: function() {},

        imageUpload: false,
        imageFormats: ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'webp'],
        imageUploadURL: '',
        crossDomainUpload: false,
        uploadCallbackURL: '',
        toc: true, // Table of contents
        tocm: false, // Using [TOCM], auto create ToC dropdown menu
        tocTitle: '', // for ToC dropdown menu btn
        tocDropdown: false,
        tocContainer: '',
        tocStartLevel: 1, // Said from H1 to create ToC
        htmlDecode: false, // Open the HTML tag identification
        // pageBreak: true, // Enable parse page break [========]
        atLink: true, // for @link
        // emailLink: true, // for email address auto link
        // taskList: false, // Enable Github Flavored Markdown task lists
        // emoji: false, // :emoji: , Support Github emoji, Twitter Emoji (Twemoji);
        // Support FontAwesome icon emoji :fa-xxx: > Using fontAwesome icon web fonts;
        // Support Editor.md logo icon emoji :editormd-logo: :editormd-logo-1x: > 1~8x;
        // tex: false, // TeX(LaTeX), based on KaTeX
        // flowChart: false, // flowChart.js only support IE9+
        // sequenceDiagram: false, // sequenceDiagram.js only support IE9+
        // previewCodeHighlight: true,

        toolbar: true, // show/hide toolbar
        toolbarAutoFixed: true, // on window scroll auto fixed position
        toolbarIcons: 'full',
        toolbarTitles: {},
        toolbarHandlers: {
            ucwords: function() {
                return utils.ucwords;
            },
            lowercase: function() {
                // return editormd.toolbarHandlers.lowercase
            },
        },
        toolbarCustomIcons: {
            // using html tag create toolbar icon, unused default <a> tag.
            lowercase:
                '<a href="javascript:;" title="Lowercase" unselectable="on"><i class="fa" name="lowercase" style="font-size:24px;margin-top: -10px;">a</i></a>',
            ucwords:
                '<a href="javascript:;" title="ucwords" unselectable="on"><i class="fa" name="ucwords" style="font-size:20px;margin-top: -3px;">Aa</i></a>',
        },

        lang: {
            name: 'zh-cn',
            description: '开源在线Markdown编辑器<br/>Open source online Markdown editor.',
            tocTitle: '目录',
            toolbar: {
                undo: '撤销（Ctrl+Z）',
                redo: '重做（Ctrl+Y）',
                bold: '粗体',
                del: '删除线',
                italic: '斜体',
                quote: '引用',
                ucwords: '将每个单词首字母转成大写',
                uppercase: '将所选转换成大写',
                lowercase: '将所选转换成小写',
                h1: '标题1',
                h2: '标题2',
                h3: '标题3',
                h4: '标题4',
                h5: '标题5',
                h6: '标题6',
                'list-ul': '无序列表',
                'list-ol': '有序列表',
                hr: '横线',
                link: '链接',
                'reference-link': '引用链接',
                image: '添加图片',
                code: '添加代码',
                'preformatted-text': '预格式文本 / 代码块（缩进风格）',
                'code-block': '代码块（多语言风格）',
                file: '上传.ipynb文件',
                table: '添加表格',
                datetime: '日期时间',
                emoji: 'Emoji表情',
                'html-entities': 'HTML实体字符',
                pagebreak: '插入分页符',
                'goto-line': '跳转到行',
                watch: '实时预览',
                unwatch: '开启实时预览',
                preview: '全窗口预览HTML（按 Shift + ESC还原）',
                fullscreen: '全屏（按ESC还原）',
                clear: '清空',
                search: '搜索',
                help: '使用帮助',
                // info: '关于' + (this as any).title,
                info: '关于', // todo this.title编译不通过，不知道社区里的的代码是怎么编译通过的
            },
            buttons: {
                enter: '确定',
                cancel: '取消',
                close: '关闭',
            },
            dialog: {
                link: {
                    title: '添加链接',
                    url: '链接地址',
                    urlTitle: '链接标题',
                    urlEmpty: '错误：请填写链接地址。',
                },
                referenceLink: {
                    title: '添加引用链接',
                    name: '引用名称',
                    url: '链接地址',
                    urlId: '链接ID',
                    urlTitle: '链接标题',
                    nameEmpty: '错误：引用链接的名称不能为空。',
                    idEmpty: '错误：请填写引用链接的ID。',
                    urlEmpty: '错误：请填写引用链接的URL地址。',
                },
                image: {
                    title: '添加图片',
                    url: '图片地址',
                    link: '图片链接',
                    alt: '图片描述',
                    uploadButton: '本地上传',
                    imageURLEmpty: '错误：图片地址不能为空。',
                    uploadFileEmpty: '错误：上传的图片不能为空。',
                    formatNotAllowed: '错误：只允许上传图片文件，允许上传的图片文件格式有：',
                },
                file: {
                    title: '添加文件',
                    url: '文件地址',
                    link: '文件链接',
                    alt: '文件描述',
                    uploadButton: '本地上传',
                    imageURLEmpty: '错误:文件地址不能为空',
                    uploadFileEmpty: '错误：上传的文件不能为空。',
                    formatNotAllowed: '错误：只允许上传.ipynb文件，允许上传的文件格式有：',
                },
                preformattedText: {
                    title: '添加预格式文本或代码块',
                    emptyAlert: '错误：请填写预格式文本或代码的内容。',
                },
                codeBlock: {
                    title: '添加代码块',
                    selectLabel: '代码语言：',
                    selectDefaultText: '请选择代码语言',
                    otherLanguage: '其他语言',
                    unselectedLanguageAlert: '错误：请选择代码所属的语言类型。',
                    codeEmptyAlert: '错误：请填写代码内容。',
                },
                htmlEntities: {
                    title: 'HTML 实体字符',
                },
                help: {
                    title: '使用帮助',
                },
            },
        },
    },

    loadFiles: {
        script: [],
        style: [],
        css: [],
        plugin: [],
    },

    loadPlugins: {},

    /**
     *
     * @param {Array} markdownToC 用于接收TOC的数组
     * @param {Object} options 自定义配置选项
     */
    createMarkedRender: function(markdownToC: Array<any>, options: any) {
        const settings = utils.extend(
            {
                toc: true, // Table of contents
                tocm: false,
                tocStartLevel: 1, // Said from H1 to create ToC
                pageBreak: true,
                atLink: true, // for @link
                emailLink: true, // for mail address auto link
                taskList: false, // Enable Github Flavored Markdown task lists
                emoji: false, // :emoji: , Support Twemoji, fontAwesome, Editor.md logo emojis.
                tex: false, // TeX(LaTeX), based on KaTeX
                flowChart: false, // flowChart.js only support IE9+
                sequenceDiagram: false, // sequenceDiagram.js only support IE9+
            },
            options || {}
        );

        const markedRenderer: any = new Marked.Renderer();
        markdownToC = markdownToC || [];

        const atLinkReg = regexs.atLink;
        const mentionLinkReg = regexs.mentionLink;
        const emojiReg = regexs.emoji;
        const emailReg = regexs.email;
        const emailLinkReg = regexs.emailLink;
        const twemojiReg = regexs.twemoji;
        const faIconReg = regexs.fontAwesome;
        const editormdLogoReg = regexs.editormdLogo;
        const pageBreakReg = regexs.pageBreak;

        markedRenderer.emoji = function(text: string) {
            text = text.replace(regexs.emojiDatetime, function($1) {
                return $1.replace(/:/g, '&#58;');
            });

            const matchs = text.match(emojiReg);

            if (!matchs || !settings.emoji) {
                return text;
            }

            for (let i = 0, len = matchs.length; i < len; i++) {
                if (matchs[i] === ':+1:') {
                    matchs[i] = ':\\+1:';
                }

                text = text.replace(new RegExp(matchs[i]), function($1: string, $2: string): string {
                    // font awesome
                    const faMatchs = $1.match(faIconReg);
                    const name = $1.replace(/:/g, '');

                    if (faMatchs) {
                        for (let fa = 0, len1 = faMatchs.length; fa < len1; fa++) {
                            const faName = faMatchs[fa].replace(/:/g, '');
                            return (
                                '<i class="fa ' + faName + ' fa-emoji" title="' + faName.replace('fa-', '') + '"></i>'
                            );
                        }
                    } else {
                        const emdlogoMathcs = $1.match(editormdLogoReg);
                        const twemojiMatchs = $1.match(twemojiReg);

                        if (emdlogoMathcs) {
                            for (let x = 0, len2 = emdlogoMathcs.length; x < len2; x++) {
                                const logoName = emdlogoMathcs[x].replace(/:/g, '');
                                return '<i class="' + logoName + '" title="Editor.md logo (' + logoName + ')"></i>';
                            }
                        } else if (twemojiMatchs) {
                            for (let t = 0, len3 = twemojiMatchs.length; t < len3; t++) {
                                const twe = twemojiMatchs[t].replace(/:/g, '').replace('tw-', '');
                                return (
                                    '<img src="' +
                                    emoji.twemoji.path +
                                    twe +
                                    emoji.twemoji.ext +
                                    '" title="twemoji-' +
                                    twe +
                                    '" alt="twemoji-' +
                                    twe +
                                    '" class="emoji twemoji" />'
                                );
                            }
                        } else {
                            let src = name === '+1' ? 'plus1' : name;
                            src = src === 'black_large_square' ? 'black_square' : src;
                            src = src === 'moon' ? 'waxing_gibbous_moon' : src;

                            return (
                                '<img src="' +
                                emoji.emoji.path +
                                src +
                                emoji.emoji.ext +
                                '" class="emoji" title="&#58;' +
                                name +
                                '&#58;" alt="&#58;' +
                                name +
                                '&#58;" />'
                            );
                        }
                    }
                    return '';
                });
            }

            return text;
        };

        markedRenderer.atLink = function(text: string) {
            if (atLinkReg.test(text)) {
                // metion link
                if (settings.mentionLink && mentionLinkReg.test(text)) {
                    text = text.replace(mentionLinkReg, function($1: string, $2: string) {
                        return (
                            '<a href="' +
                            settings.mentionLinkBase +
                            '' +
                            $2 +
                            '" title="&#64;' +
                            $2 +
                            '" class="mention-link">' +
                            $1 +
                            '</a>'
                        );
                    });
                } else if (settings.atLink) {
                    text = text.replace(emailReg, function($1: string, $2: string, $3: string, $4: string) {
                        return $1.replace(/@/g, '_#_&#64;_#_');
                    });

                    text = text
                        .replace(atLinkReg, function($1: string, $2: string) {
                            return (
                                '<a href="' +
                                settings.atLinkBase +
                                '' +
                                $2 +
                                '" title="&#64;' +
                                $2 +
                                '" class="at-link">' +
                                $1 +
                                '</a>'
                            );
                        })
                        .replace(/_#_&#64;_#_/g, '@');
                }

                if (settings.emailLink) {
                    text = text.replace(emailLinkReg, function($1: string, $2: string, $3: string, $4: string, $5: string) {
                        return !$2 && $.inArray($5, 'jpg|jpeg|png|gif|webp|ico|icon|pdf'.split('|')) < 0
                            ? '<a href="mailto:' + $1 + '">' + $1 + '</a>'
                            : $1;
                    });
                }

                return text;
            }

            return text;
        };

        markedRenderer.link = function(href: string, title: string, text: string) {
            if (this.options.sanitize) {
                try {
                    const prot = decodeURIComponent(unescape(href))
                        .replace(/[^\w:]/g, '')
                        .toLowerCase();
                    if (prot.indexOf('javascript:') === 0) {
                        return '';
                    }
                } catch (e) {
                    return '';
                }
            }

            let out = '<a href="' + href + '"';

            if (atLinkReg.test(title) || atLinkReg.test(text)) {
                if (title) {
                    out += ' title="' + title.replace(/@/g, '&#64;');
                }

                return out + '">' + text.replace(/@/g, '&#64;') + '</a>';
            }

            if (title) {
                out += ' title="' + title + '"';
            }

            out += '>' + text + '</a>';

            return out;
        };

        markedRenderer.heading = function(text: any, level: string | number, raw?: any) {
            const linkText = text;
            const hasLinkReg = /\s*<a\s*href="(.*)"\s*([^>]*)>(.*)<\/a>\s*/;
            // var getLinkTextReg = /\s*\<a\s*([^\>]+)\>([^\>]*)\<\/a\>\s*/g;

            if (hasLinkReg.test(text)) {
                const tempText = [];
                text = text.split(/<a\s*([^>]+)>([^>]*)<\/a>/);

                for (let i = 0, len = text.length; i < len; i++) {
                    tempText.push(text[i].replace(/\s*href="(.*)"\s*/g, ''));
                }

                text = tempText.join(' ');
            }

            text = utils.trim(text);

            const escapedText = text.toLowerCase().replace(/[^\w]+/g, '-');
            const toc = {
                text: text,
                level: level,
                slug: escapedText,
            };

            const isChinese = /^[\u4e00-\u9fa5]+$/.test(text);
            const id = isChinese ? escape(text).replace(/%/g, '') : text.toLowerCase().replace(/[^\w]+/g, '-');

            markdownToC.push(toc);

            let headingHTML = '<h' + level + ' id="h' + level + '-' + this.options.headerPrefix + id + '">';

            headingHTML += '<a name="' + text + '" class="reference-link"></a>';
            headingHTML += '<span class="header-link octicon octicon-link"></span>';
            headingHTML += hasLinkReg ? this.atLink(this.emoji(linkText)) : this.atLink(this.emoji(text));
            headingHTML += '</h' + level + '>';

            return headingHTML;
        };

        markedRenderer.pageBreak = function(text: any) {
            if (pageBreakReg.test(text) && settings.pageBreak) {
                text = '<hr style="page-break-after:always;" class="page-break editormd-page-break" />';
            }

            return text;
        };

        markedRenderer.paragraph = function(text: any) {
            const isTeXInline = /\$\$(.*)\$\$/g.test(text);
            const isTeXLine = /^\$\$(.*)\$\$$/.test(text);
            const isTeXAddClass = isTeXLine ? ' class="' + classNames.tex + '"' : '';
            const isToC = settings.tocm ? /^(\[TOC\]|\[TOCM\])$/.test(text) : /^\[TOC\]$/.test(text);
            const isToCMenu = /^\[TOCM\]$/.test(text);

            if (!isTeXLine && isTeXInline) {
                text = text.replace(/(\$\$([^$]*)\$\$)+/g, function($1: string, $2: string) {
                    return '<span class="' + classNames.tex + '">' + $2.replace(/\$/g, '') + '</span>';
                });
            } else {
                text = isTeXLine ? text.replace(/\$/g, '') : text;
            }

            const tocHTML = '<div class="markdown-toc-container">' + text + '</div>';

            return isToC
                ? isToCMenu
                    ? '<div class="editormd-toc-menu">' + tocHTML + '</div><br/>'
                    : tocHTML
                : pageBreakReg.test(text)
                ? this.pageBreak(text)
                : '<p' + isTeXAddClass + '>' + this.atLink(this.emoji(text)) + '</p>\n';
        };

        markedRenderer.code = function(...thisArgs) {
            const code = thisArgs[0];
            const lang = thisArgs[1];
            if (lang === 'seq' || lang === 'sequence') {
                return '<div class="sequence-diagram">' + code + '</div>';
            } else if (lang === 'flow') {
                return '<div class="flowchart">' + code + '</div>';
            } else if (lang === 'math' || lang === 'latex' || lang === 'katex') {
                return '<p class="' + classNames.tex + '">' + code + '</p>';
            } else {
                return Marked.Renderer.prototype.code.apply(this, thisArgs);
            }
        };

        markedRenderer.tablecell = function(content: any, flags: any) {
            const type = flags.header ? 'th' : 'td';
            const tag = flags.align ? '<' + type + ' style="text-align:' + flags.align + '">' : '<' + type + '>';

            return tag + this.atLink(this.emoji(content)) + '</' + type + '>\n';
        };

        markedRenderer.listitem = function(text: string) {
            if (settings.taskList && /^\s*\[[x\s]\]\s*/.test(text)) {
                text = text
                    .replace(/^\s*\[\s\]\s*/, '<input type="checkbox" class="task-list-item-checkbox" /> ')
                    .replace(
                        /^\s*\[x\]\s*/,
                        '<input type="checkbox" class="task-list-item-checkbox" checked disabled /> '
                    );

                return '<li style="list-style: none;">' + this.atLink(this.emoji(text)) + '</li>';
            } else {
                return '<li>' + this.atLink(this.emoji(text)) + '</li>';
            }
        };

        return markedRenderer;
    },

    /**
     * 简单地过滤指定的HTML标签
     * Filter custom html tags
     *
     * @param   {String}   html          要过滤HTML
     * @param   {String}   filters       要过滤的标签
     * @returns {String}   html          返回过滤的HTML
     */

    filterHTMLTags(html: any, filters: any) {
        if (typeof html !== 'string') {
            html = String(html);
        }

        if (typeof filters !== 'string') {
            return html;
        }

        const expression = filters.split('|');
        const filterTags = expression[0].split(',');
        const attrs = expression[1];

        for (let i = 0, len = filterTags.length; i < len; i++) {
            const tag = filterTags[i];

            html = html.replace(new RegExp('<s*' + tag + 's*([^>]*)>([^>]*)<s*/' + tag + 's*>', 'igm'), '');
        }

        // return html;

        if (typeof attrs !== 'undefined') {
            const htmlTagRegex = /<(\w+)\s*([^>]*)>([^>]*)<\/(\w+)>/gi;

            if (attrs === '*') {
                html = html.replace(htmlTagRegex, function($1: string, $2: string, $3: string, $4: string, $5: string) {
                    return '<' + $2 + '>' + $4 + '</' + $5 + '>';
                });
            } else if (attrs === 'on*') {
                html = html.replace(htmlTagRegex, function($1: string, $2: string, $3: string, $4: string, $5: string) {
                    const el = $('<' + $2 + '>' + $4 + '</' + $5 + '>');
                    const _attrs = $($1)[0].attributes;
                    const $attrs: {[key: string]: any} = {};

                    $.each(_attrs, function(i: any, e: any) {
                        if (e.nodeName !== '"') $attrs[e.nodeName] = e.nodeValue;
                    });

                    $.each($attrs, function(i: any) {
                        if (i.indexOf('on') === 0) {
                            delete $attrs[i];
                        }
                    });

                    el.attr($attrs);

                    const text = typeof el[1] !== 'undefined' ? $(el[1]).text() : '';

                    return el[0].outerHTML + text;
                });
            } else {
                html = html.replace(htmlTagRegex, function($1: any, $2: any, $3: any, $4: any) {
                    const filterAttrs = attrs.split(',');
                    const el = $($1);
                    el.html($4);

                    $.each(filterAttrs, function(i: any) {
                        el.attr(filterAttrs[i], null);
                    });

                    return el[0].outerHTML;
                });
            }
        }

        return html;
    },
};

export default editormd;
